jQuery(document).ready(function ($) {
    $(".navbar-toggler-open").click(function () {
        $(".site-header").addClass("menu_active");
        $("body").addClass("toggle_menu_active");
    });

    $(".navbar-toggler-close").click(function () {
        $(".site-header").removeClass("menu_active");
        $("body").removeClass("toggle_menu_active");
        if ($('nav.primary-navigation button.submenu-toggle').hasClass("active")) {
            $("nav.primary-navigation button.submenu-toggle").removeClass("active");
            $("nav.primary-navigation li.menu-item").removeClass("open");
            $("nav.primary-navigation .sub-menu").slideUp();
        }
    });

    $('nav.primary-navigation').find('li.menu-item-has-children > a').after('<button class="submenu-toggle"><svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.7265 5.85938C5.88275 6.01562 6.1015 6.01562 6.25775 5.85938L10.8828 1.26562C11.039 1.14062 11.039 0.890625 10.8828 0.734375L10.2578 0.140625C10.1328 -0.015625 9.88275 -0.015625 9.7265 0.140625L6.00775 3.82812L2.25775 0.140625C2.1015 -0.015625 1.88275 -0.015625 1.7265 0.140625L1.1015 0.734375C0.945251 0.890625 0.945251 1.14062 1.1015 1.26562L5.7265 5.85938Z" fill="#0C2859"/></svg></button>');
    $('body').on('click', 'nav.primary-navigation button.submenu-toggle', function () {
        $(this).parent().siblings().find('button.submenu-toggle').removeClass("active");
        $(this).parent().siblings().find('button.submenu-toggle').parent().find('> .sub-menu').slideUp().parent().removeClass('open');
        $(this).toggleClass('active').parent().find('> .sub-menu').slideToggle().parent().toggleClass('open');
    });

    offsetLeft();

    jQuery(".team_list__item__inner .hover_link").click(function () {
        setTimeout(function () {
            $('.lity').addClass('team_popup_open');
            $('body').addClass('team_popup_active');
        });
    });

    jQuery(document).on('lity:close', function (event, instance) {
        $('.lity').removeClass('team_popup_open');
        $('body').removeClass('team_popup_active');
    });

    $('.team__popup__inner .close').on('click', function () {
        $('.lity-container>.lity-close').trigger("click");
    });


});

function offsetLeft() {
    if ((jQuery('.two_boxes_images_inner_right_img').length > 0)) {
        var boxesoffset = jQuery('.two_boxes_images_inner_right_img').offset(),
            boxeswindWidth = jQuery(window).width();
        jQuery('.two_boxes_images_inner_right_img').css('width', (boxeswindWidth - boxesoffset.left));
    }
}

jQuery(window).resize(function () {
    offsetLeft();
});

jQuery(window).load(function () {
    offsetLeft();
});